import { render, staticRenderFns } from "./ContainerInformation.vue?vue&type=template&id=2431047a&scoped=true&"
import script from "./ContainerInformation.vue?vue&type=script&lang=js&"
export * from "./ContainerInformation.vue?vue&type=script&lang=js&"
import style0 from "./ContainerInformation.vue?vue&type=style&index=0&id=2431047a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2431047a",
  null
  
)

export default component.exports